import {AuthType, AuthTypeEnum, BaseAuthenticationMethod} from './base-authentication-method';

export class Mouse extends BaseAuthenticationMethod {
    type = 'mouse';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
